import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xxl-8",
  style: {"margin-top":"-30px"}
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7" }
const _hoisted_5 = { class: "symbol symbol-150px symbol-lg-150px symbol-fixed position-relative" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex align-items-center mb-2" }
const _hoisted_10 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_11 = { href: "#" }
const _hoisted_12 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center mb-4 d-none" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-1 text-primary me-4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Lugar"),
    /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('LUGARRRR'))
  ])
], -1)
const _hoisted_14 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace fs-1 text-primary me-4" }, null, -1)
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Pais", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "list-unstyled d-none" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", {
      class: /*#__PURE__*/_normalizeClass(`badge badge-success`)
    }, /*#__PURE__*/_toDisplayString('estado'))
  ])
], -1)
const _hoisted_19 = { class: "d-flex my-4 align-items-center" }
const _hoisted_20 = { class: "me-3" }
const _hoisted_21 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_22 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_23 = { class: "nav-item d-none" }
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "nav-item d-none" }
const _hoisted_26 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_btnBack = _resolveComponent("btnBack")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_image, {
                class: "w-150px h-150px",
                src: '',
                fit: 'contain'
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.club.business), 1),
                  _createElementVNode("a", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", null, _toDisplayString(_ctx.club.country), 1)
                  ])
                ]),
                _hoisted_18
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_btnBack, { to: '/institutions' })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", _hoisted_23, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/tournaments/${'5'}/manager/home`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Inicio ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_24, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/institutions/${_ctx.id}/repman`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Representantes ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_25, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/tournaments/${'5'}/manager/home`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Afiliaciones ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/institutions/${_ctx.id}/users`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Usuarios ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_router_view)
  ], 64))
}